import type { MyOrganisationDTO } from '@api/fastAPI.schemas'

/**
 * The organisation to switch to so that the active one is the project's, or
 * `null` when no switch is needed or possible.
 *
 * Without a choice (`activeOrganisationGuid === null`) the backend answers for
 * the default organisation, which is the first one listed -- so a project of
 * that organisation needs no switch. An organisation the user is not a member
 * of is never switched to.
 */
export const organisationToAdopt = (
  organisations: MyOrganisationDTO[],
  activeOrganisationGuid: string | null,
  projectOrganisationGuid: string,
): MyOrganisationDTO | null => {
  const active =
    organisations.find(organisation => organisation.guid === activeOrganisationGuid) ??
    organisations[0]
  if (active?.guid === projectOrganisationGuid) return null

  return organisations.find(organisation => organisation.guid === projectOrganisationGuid) ?? null
}
